import * as api from '../api/freeTexts'
import { FreeTextInterface } from '../Interfaces/FreeTextInterface'
import { actionCreatorAsync, AsyncAction } from './index'

export function getFreeTexts(): AsyncAction<FreeTextInterface[]> {
  return actionCreatorAsync<FreeTextInterface[]>('GET_FREETEXTS', async () => api.getFreeTexts())
}

export function saveFreeText(freeText: FreeTextInterface): AsyncAction<FreeTextInterface> {
  return actionCreatorAsync<FreeTextInterface>('SAVE_FREETEXT', async () => api.saveFreeText(freeText))
}

export function deleteFreeText(id: number): AsyncAction<number> {
  return actionCreatorAsync<number>('DELETE_FREETEXT', async () => api.deleteFreeText(id))
}
